import React from 'react';
import ReactDOM from 'react-dom/client';
import 'assets/styles/styles.css';
import RootTemplate from 'templates/RootTemplate';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLDivElement);

root.render(<RootTemplate />);
